module.exports = __webpack_public_path__ + "static/media/riptide.01c165bf.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/riptide.jpg
 ** module id = 436
 ** module chunks = 0
 **/